// TODO: as a common util;
type Task<T = unknown> = Promise<T> & { resolve: () => void };

/** Promise with resolve (self) */
function createTask<T = unknown>(): Task<T> {
    let resolve;
    const promise = new Promise(res => resolve = res) as Task<T>;
    promise.resolve = resolve;

    return promise;
}

export const waitForSlideModelReady = createTask();
